import type { OrgTipo } from './navigation';

/** Paleta profesional por rubro clínico (no todo teal genérico). */
export const ORG_BRAND: Record<string, { primary: string; accent: string; emoji: string; label: string }> = {
  'clinica-medica': { primary: '#2563eb', accent: '#1d4ed8', emoji: '🩺', label: 'Medicina general' },
  'clinica-odontologica': { primary: '#0891b2', accent: '#0e7490', emoji: '🦷', label: 'Odontología' },
  'clinica-veterinaria': { primary: '#059669', accent: '#047857', emoji: '🐾', label: 'Veterinaria' },
  'clinica-nutricion': { primary: '#65a30d', accent: '#4d7c0f', emoji: '🥗', label: 'Nutrición' },
  'clinica-psicologia': { primary: '#7c3aed', accent: '#6d28d9', emoji: '🧠', label: 'Psicología' },
  'clinica-estetica': { primary: '#db2777', accent: '#be185d', emoji: '✨', label: 'Estética' },
  'clinica-optica': { primary: '#4f46e5', accent: '#4338ca', emoji: '👓', label: 'Óptica' },
  'clinica-fisioterapia': { primary: '#0284c7', accent: '#0369a1', emoji: '🏃', label: 'Fisioterapia' },
};

export function orgBrand(orgTipo: string | null | undefined) {
  if (orgTipo && ORG_BRAND[orgTipo]) return ORG_BRAND[orgTipo];
  return ORG_BRAND['clinica-medica'];
}

export function orgLabel(orgTipo: string | null | undefined): string {
  return orgBrand(orgTipo).label;
}

/** Iniciales para avatar cuando no hay logo propio (máx. 2 letras). */
export function clinicInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  const w = words[0] ?? 'CL';
  return w.slice(0, 2).toUpperCase();
}

export function isOrgTipo(v: string | null | undefined): v is OrgTipo {
  return !!v && v in ORG_BRAND;
}
